const AccountTitleGroupEvent = {
  fetchAll: 'account-title-group/fetch-details'
}

export default AccountTitleGroupEvent
